import { ILoggerService } from './logger.interface';
import { injectable } from 'inversify';

@injectable()
export class LoggerMock implements ILoggerService {
    debug = console.debug;
    info = console.info;
    warn = console.warn;
    error = console.error;
}
